import { useState, useEffect } from 'react';
import { useCompany } from './useCompany';



function matchCategoryDescriptions(workflows, categories) {
  return workflows.reduce((accumulator, workflow) => {
    const category = categories.find(cat => cat.categoryId === workflow.categoryId);
    accumulator[workflow.workflowId] = {
      ...workflow,
      categoryDescription: category ? category.description : null,
    };
    return accumulator;
  }, {});
}

function prepareDropdown(arr, label, value) {
  const seen = new Set();
  const uniqueOptions = [];
  arr.forEach(obj => {
    if (!seen.has(obj[value])) {
      seen.add(obj[value]);
      uniqueOptions.push({ label: obj[label], value: obj[value] });
    }
  });
  return uniqueOptions;
}

export function useWorkflowsForCompany(companyCode, refreshFlag) {
  const { getWorkflows, getWorkflowCategories } = useCompany();
  const [workflows, setWorkflows] = useState([]);
  const [workflowObjs, setWorkflowObjs] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyCode) {
      setWorkflows([]);
      setWorkflowObjs({});
      return;
    }

    setLoading(true);
    getWorkflows({ company: companyCode })
      .then(res => {
        const workflowsData = res?.data || [];
        const options = prepareDropdown(workflowsData, 'description', 'workflowId');
        setWorkflows(options);

        return getWorkflowCategories().then(catRes => {
          const categories = catRes?.data || [];
          const mappedObjs = matchCategoryDescriptions(workflowsData, categories);
          setWorkflowObjs(mappedObjs);
        });
      })
      .catch(() => {
        setWorkflows([]);
        setWorkflowObjs({});
      })
      .finally(() => setLoading(false));
  }, [companyCode, refreshFlag]);

  return { workflows, workflowObjs, loading };
}